const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"y4w9YwqVi3GE5qJ3hdIil"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["koolumbus-portal@myothis"]={id:"y4w9YwqVi3GE5qJ3hdIil"};
      